<template>
  <div class="form-box">
    <template v-for="formItem in signFormFormat">
      <van-field
        v-if="formItem.type === 'text'"
        :key="formItem.key"
        v-model="formData[formItem.key]"
        :name="formItem.key"
        :label="formItem.label"
        :maxlength="
          formItem.key === 'name'
            ? 10
            : formItem.key === 'nation' || formItem.key === 'school'
            ? 20
            : 50
        "
        :disabled="formItem.key === 'name' && namePhoneDisabled === 'name'"
        :placeholder="formItem.placeholder || `请输入${formItem.label}`"
        :required="formItem.required"
        :rules="[
          {
            required: formItem.required,
            message: formItem.placeholder,
            trigger: 'onBlur',
          },
        ]"
      />
      <van-field
        v-if="formItem.type === 'phone'"
        :key="formItem.key"
        v-model="formData[formItem.key]"
        :name="formItem.key"
        :label="formItem.label"
        placeholder="请输入手机号"
        :disabled="namePhoneDisabled !== 'none'"
        :required="formItem.required"
        :rules="[
          {
            required: formItem.required,
            message: '请输入手机号',
            trigger: 'onBlur',
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确格式的手机号码',
            trigger: 'onBlur',
          },
          {
            validator: phoneValidator,
            message: '输入的手机号码重复，请检查后重新填写！',
            trigger: 'onBlur',
          },
        ]"
        @blur="phoneBlur"
      >
        <template #button v-if="!isUserPhone && isCheckPhone">
          <van-field
            class="verify-btn-box"
            :rules="[
              {
                required: true,
                message: '请验证手机号',
                trigger: 'onchange',
              },
            ]"
          >
            <template #input>
              <div class="verify-btn" @click="toCheckPhone">
                {{ formData.isPhone ? "已验证" : "验证手机号" }}
              </div>
              <van-switch v-show="false" v-model="formData.isPhone" size="20" />
            </template>
          </van-field>
        </template>
      </van-field>
      <van-field
        v-else-if="formItem.type === 'headPhoto'"
        :key="formItem.key"
        :name="formItem.key"
        :label="formItem.label"
        :required="formItem.required"
        :rules="[
          {
            required: formItem.required,
            message: formItem.placeholder,
            trigger: 'onChange',
          },
        ]"
      >
        <template #input>
          <van-uploader
            class="headPhoto-box"
            v-model="formData.headPhoto"
            upload-icon="user-o"
            preview-size="80px"
            :max-count="1"
            :max-size="2 * 1024 * 1024"
            :before-read="beforeRead"
            :after-read="clzpAfterRead"
            @oversize="onOversize(2)"
          >
          </van-uploader>
        </template>
      </van-field>
      <van-field
        v-else-if="formItem.type === 'sex'"
        :key="formItem.key"
        :name="formItem.key"
        :label="formItem.label"
        :required="formItem.required"
        :rules="[
          {
            required: formItem.required,
            message: formItem.placeholder,
            trigger: 'onChange',
          },
        ]"
      >
        <template #input>
          <van-radio-group
            class="radio-box"
            v-model="formData[formItem.key]"
            direction="horizontal"
          >
            <van-radio name="男">
              <template #icon="props">
                <van-button
                  native-type="button"
                  round
                  type="info"
                  :class="[
                    'radio-btn-default',
                    { 'radio-btn-active': props.checked },
                  ]"
                  >男</van-button
                >
              </template>
            </van-radio>
            <van-radio name="女">
              <template #icon="props">
                <van-button
                  native-type="button"
                  round
                  type="info"
                  :class="[
                    'radio-btn-default',
                    { 'radio-btn-active': props.checked },
                  ]"
                  >女</van-button
                >
              </template>
            </van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        :key="formItem.key"
        v-else-if="
          formItem.type === 'birthday' ||
          formItem.type == 'education' ||
          formItem.type == 'dropDown' ||
          formItem.type === 'date'
        "
        v-model="formData[formItem.key]"
        :label="formItem.label"
        :name="formItem.key"
        readonly
        is-link
        :placeholder="formItem.placeholder || `请选择${formItem.label}`"
        :required="formItem.required"
        :rules="[
          {
            required: formItem.required,
            message: formItem.placeholder,
            trigger: 'onChange',
          },
        ]"
        @click="
          showItemOverlay(
            formItem.type,
            formItem.key,
            formItem.options,
            formItem.format
          )
        "
      />
      <template v-else-if="formItem.type === 'titles'">
        <div :key="formItem.key">
          <van-field :label="formItem.label" :required="formItem.required">
            <template #input>
              <div class="titles-box">
                <div
                  class="titles-item"
                  v-for="(titleInfo, titleInd) in formData.titles"
                  :key="titleInd"
                >
                  <van-field
                    class="title-pick"
                    v-model="titleInfo.levelOneName"
                    :name="formItem.key + '.' + titleInd + '.levelOne'"
                    readonly
                    is-link
                    placeholder="选职级"
                    :rules="[
                      {
                        required: formItem.required,
                        message: formItem.placeholder,
                        trigger: 'onChange',
                      },
                    ]"
                    @click="showItemOverlay(formItem.type, titleInd)"
                  >
                  </van-field>
                  <van-field
                    v-model="titleInfo.levelTwo"
                    :disabled="titleInfo.levelOne == 5"
                    :name="formItem.key + '.' + titleInd + '.levelTwo'"
                    :maxlength="10"
                    :rules="[
                      {
                        required: formItem.required && titleInfo.levelOne != 5,
                        message: formItem.placeholder,
                        trigger: 'onChange',
                      },
                    ]"
                    placeholder="请输入职称"
                  />
                  <van-button
                    v-show="formItem.isMultiple && formData.titles.length > 1"
                    class="right-btn"
                    type="default"
                    round
                    native-type="button"
                    @click="formData.titles.splice(titleInd, 1)"
                    ><span class="right"></span
                  ></van-button>
                </div>
              </div>
            </template>
          </van-field>
          <div class="line"></div>
          <van-button
            native-type="button"
            class="add-btn"
            type="default"
            v-if="formItem.isMultiple && formData.titles.length < 5"
            @click="addTitleInfo"
            >增加</van-button
          >
        </div>
      </template>
      <template v-else-if="formItem.type === 'subjects'">
        <div :key="formItem.key">
          <van-field :label="formItem.label" :required="formItem.required">
            <template #input>
              <div class="subject-box">
                <div
                  class="subject-item"
                  v-for="(subjectInfo, subjectInd) in formData.subjects"
                  :key="subjectInd"
                >
                  <van-field
                    v-model="subjectInfo.fieldValue"
                    :name="formItem.key + '.' + subjectInd + '.fieldValue'"
                    :placeholder="formItem.placeholder"
                    is-link
                    readonly
                    :rules="[
                      {
                        required: formItem.required,
                        message: formItem.placeholder,
                        trigger: 'onChange',
                      },
                    ]"
                    @click="showItemOverlay(formItem.type, subjectInd)"
                  />
                  <van-button
                    v-show="formItem.isMultiple && formData.subjects.length > 1"
                    class="right-btn"
                    type="default"
                    round
                    native-type="button"
                    @click="formData.subjects.splice(subjectInd, 1)"
                    ><span class="right"></span
                  ></van-button>
                </div>
              </div>
            </template>
          </van-field>
          <div class="line"></div>
          <van-button
            native-type="button"
            class="add-btn"
            type="default"
            v-if="formItem.isMultiple && formData.subjects.length < 5"
            @click="addSubjectInfo"
            >增加</van-button
          >
        </div>
      </template>
      <template v-else-if="formItem.type === 'org'">
        <van-field
          :key="formItem.key"
          :label="formItem.label"
          :required="formItem.required"
        >
          <template #input>
            <div class="org-box">
              <div
                v-for="orgItem in formItem.format.split('-')"
                :key="orgItem"
                class="org-item"
              >
                <van-field
                  v-if="orgItem === 'city'"
                  :value="areaName"
                  :placeholder="phFilter(orgItem)"
                  :name="formItem.key + '.' + orgItem"
                  :readonly="orgItem === 'city'"
                  :is-link="orgItem === 'city'"
                  :rules="[
                    {
                      required: formItem.required,
                      message: phFilter(orgItem),
                      trigger: 'blur' | 'change',
                    },
                  ]"
                  @click="showItemOverlay('area')"
                />
                <van-field
                  v-else
                  v-model.trim="formData[formItem.key][orgItem]"
                  :placeholder="phFilter(orgItem)"
                  :name="formItem.key + '.' + orgItem"
                  :maxlength="20"
                  :rules="[
                    {
                      required: formItem.required,
                      message: phFilter(orgItem),
                      trigger: 'blur' | 'change',
                    },
                  ]"
                />
              </div>
            </div>
          </template>
        </van-field>
      </template>
      <van-field
        v-else-if="formItem.type === 'singleChoice'"
        :key="formItem.key"
        :name="formItem.key"
        :label="formItem.label"
        :required="formItem.required"
        :rules="[
          {
            required: formItem.required,
            message: formItem.placeholder,
            trigger: 'onChange',
          },
        ]"
      >
        <template #input>
          <div class="customize-radio-box">
            <p class="tip">
              {{ formItem.placeholder || `请选择${formItem.label}` }}
            </p>
            <van-radio-group v-model="formData[formItem.key]">
              <van-cell-group>
                <van-cell
                  class="customize-radio-item"
                  v-for="(checekItem, checekIndex) in formItem.options"
                  :key="checekIndex"
                  :title="checekItem.value"
                  clickable
                  @click="radioClick(formItem.key, checekItem.value)"
                >
                  <template #right-icon>
                    <van-radio :name="checekItem.value" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </div>
        </template>
      </van-field>
      <van-field
        v-else-if="formItem.type === 'multipleChoice'"
        :key="formItem.key"
        :name="formItem.key"
        :label="formItem.label"
        :required="formItem.required"
        :rules="[
          {
            required: formItem.required,
            message: formItem.placeholder,
            trigger: 'onChange',
          },
        ]"
      >
        <template #input>
          <div class="customize-radio-box">
            <p class="tip">
              {{ formItem.placeholder || `请选择${formItem.label}` }}
            </p>
            <van-checkbox-group v-model="formData[formItem.key]">
              <van-cell-group>
                <van-cell
                  class="customize-radio-item"
                  v-for="(checekItem, checekIndex) in formItem.options"
                  :key="checekIndex"
                  clickable
                  :title="checekItem.value"
                  @click="checkToggle(checekIndex)"
                >
                  <template #right-icon>
                    <van-checkbox
                      shape="square"
                      :name="checekItem.value"
                      ref="checkboxes"
                    />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </div>
        </template>
      </van-field>
      <van-field
        :key="formItem.key"
        v-else-if="formItem.type === 'imageList'"
        :name="formItem.key"
        :label="formItem.label"
        :required="formItem.required"
        :rules="[
          {
            required: formItem.required,
            message: formItem.placeholder,
            trigger: 'onChange',
          },
        ]"
      >
        <template #input>
          <div style="width: 100%">
            <p class="tip">
              {{ formItem.placeholder || `请上传${formItem.label}` }}
            </p>
            <van-uploader
              v-model="formData[formItem.key]"
              :max-count="formItem.isMultiple ? 5 : 1"
              :max-size="5 * 1024 * 1024"
              :before-read="beforeRead"
              :after-read="clzpAfterRead"
              @oversize="onOversize(5)"
            />
          </div>
        </template>
      </van-field>
      <van-field
        :key="formItem.key"
        v-else-if="formItem.type === 'file'"
        :name="formItem.key"
        :label="formItem.label"
        :required="formItem.required"
        :rules="[
          {
            required: formItem.required,
            message: formItem.placeholder,
            trigger: 'onChange',
          },
        ]"
      >
        <template #input>
          <div style="width: 100%">
            <p class="tip">
              {{ formItem.placeholder || `请上传${formItem.label}` }}
            </p>
            <van-uploader
              style="width: 100%"
              v-model="formData[formItem.key]"
              :accept="''"
              :max-count="formItem.isMultiple ? 5 : 1"
              :max-size="20 * 1024 * 1024"
              :before-read="(file) => beforeRead(file, true)"
              :after-read="clzpAfterRead"
              @oversize="onOversize(20)"
            >
              <van-button size="small" plain type="info" round
                >上传文件</van-button
              >
            </van-uploader>
          </div>
        </template>
      </van-field>
    </template>
    <van-action-sheet v-model="educationPickerStatus">
      <van-picker
        ref="eduRef"
        value-key="label"
        :show-toolbar="true"
        :columns="educationOptions"
        @confirm="(item, list) => selectAction(item, 'education', list)"
        @cancel="() => (educationPickerStatus = false)"
      />
    </van-action-sheet>
    <!-- 出生年份 picker -->
    <van-action-sheet
      v-model="birthdayPickerStatus"
      :actions="birthdayOptions"
      @select="(item) => selectAction(item, 'birthday')"
    />
    <!-- 自定义picker -->
    <van-action-sheet
      v-model="dropDownPickerStatus"
      :actions="customOptions"
      @select="(item) => selectAction(item, 'dropDown')"
    />
    <!-- 职级 picker -->
    <van-action-sheet
      v-model="titlesPickerStatus"
      :actions="titleOptions"
      @select="selectTitleLevelOne"
    />
    <!-- 学科领域弹窗  -->
    <van-popup
      v-model="subjectsPickerStatus"
      round
      position="bottom"
      @close="closeSubjectCascader"
    >
      <van-cascader
        ref="subjectsCascader"
        v-model="subjectsCascaderValue"
        active-color="#1989fa"
        title="请选择学科领域"
        :options="subjectOptions"
        :field-names="fieldNames"
        @finish="chooseSubjects"
        @close="closeSubjectCascader"
      />
    </van-popup>
    <!-- 省市弹窗  -->
    <van-popup v-model="areaPickerStatus" round position="bottom">
      <van-tabs v-model="country">
        <van-tab title="中国" :name="0" title-class="tab-box">
          <van-cascader
            v-model="areaCascaderValue"
            :show-header="false"
            active-color="#4A79F1"
            :options="areaComOptions"
            :field-names="fieldNames"
            @change="areaOnChange"
            @finish="areaOnFinish"
          />
        </van-tab>
        <van-tab title="海外" :name="1" title-class="tab-box">
          <van-cascader
            v-model="areaCascaderValue"
            :show-header="false"
            active-color="#4A79F1"
            :options="[{ label: '海外', value: 9999 }]"
            :field-names="fieldNames"
            @finish="areaOnFinish"
          />
        </van-tab>
      </van-tabs>
    </van-popup>
    <!-- 时间选择器弹窗  -->
    <van-popup
      v-model="datePickerStatus"
      round
      position="bottom"
      @close="closeDatePicker"
    >
      <van-datetime-picker
        :value="formData[dateKey]"
        :type="dateFormat | dateFormat"
        :title="dateFormat | dateTitleFormat"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onDateConfirm"
        @cancel="closeDatePicker"
      />
    </van-popup>
    <TipsDialog
      :showDialog="checkPhoneShow"
      @dialogCancel="checkPhoneShow = false"
      @dialogConfirm="checkPhonefirm"
    >
      <div class="verify-box">
        <h1>手机号验证</h1>
        <van-form class="verify-form" ref="checkPhoneRef">
          <van-field
            class="verify-form-item"
            :value="formData.phone"
            name="phone"
            disabled
            :rules="[{ required: true, message: '请输入手机号' }]"
          />
          <van-field
            class="verify-form-item"
            v-model="verifyCode"
            name="verifyCode"
            placeholder="请输入验证码"
            :rules="[{ required: true, message: '请输入验证码' }]"
          >
            <template #button>
              <div style="color: #4a79f1" @click="getCode">
                {{ verifyFlag ? "获取验证码" : verifyTime + "秒后重新获取" }}
              </div>
            </template>
          </van-field>
        </van-form>
        <VerifyCode
          ref="verifyCode"
          :boxShow="verifyShow"
          :phone="formData.phone"
          @success="handleVerifySuccess"
          @close="() => (verifyShow = false)"
        />
      </div>
    </TipsDialog>
    <div v-if="formLoading" class="loading-box">
      <van-loading />
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import TipsDialog from "@/views/mobileView/components/tipsDialog.vue";
import VerifyCode from "@/views/mobileView/My/login/VerifyCode.vue";
export default {
  name: "SignForm",
  props: [
    "isPay",
    "isCheckPhone",
    "meetingMemberList",
    "meetingItem",
    "meetingKey",
    "signFormFormat",
    "birthdayOptions",
    "titleOptions",
    "educationOptions",
    "subjectOptions",
    "areaOptions",
  ],
  components: {
    TipsDialog,
    VerifyCode,
  },
  data() {
    return {
      formLoading: false,
      checkPhoneShow: false,
      verifyPhoneList: [],
      verifyCode: "",
      verifyFlag: true,
      verifyTime: 59,
      verifyShow: false,
      formData: {
        isPhone: false,
      },
      // cascader数据对应字段格式
      fieldNames: {
        text: "label",
        value: "value",
        children: "children",
      },
      educationPickerStatus: false, // 学历picker
      birthdayPickerStatus: false, // 出生年份picker
      titlesPickerStatus: false, // 职级picker
      titleInd: 0, // 职级操作中index
      subjectsPickerStatus: false, // 学科领域picker
      subjectsCascaderValue: "", // 学科领域级联选中的值
      subjectInd: 0, // 学科领域操作中index
      areaPickerStatus: false, // 省市picker
      areaCascaderValue: "", // 省市级联选中的值
      areaComOptions: [],
      country: 0,
      dropDownPickerStatus: false,
      customKey: "",
      customOptions: [],
      datePickerStatus: false,
      dateKey: "",
      dateFormat: "yyyy-MM-dd",
      minDate: "",
      maxDate: "",
    };
  },
  created() {
    this.verifyPhoneList =
      JSON.parse(sessionStorage.getItem("verifyPhoneList")) || [];
    let dataForm = this.$global.deepClone(this.meetingItem);
    this.fillFormData(dataForm);
    if (this.meetingItem.org && this.meetingItem.org.country) {
      this.country = this.meetingItem.org.country;
    }
    this.dataFormate();
  },
  watch: {
    areaOptions: {
      handler(newV, oldV) {
        this.areaComOptions = newV;
      },
      deep: true,
      immediate: true,
    },
    formData: {
      handler(newV) {
        this.$emit("formChange", newV);
      },
      deep: true,
    },
  },
  computed: {
    areaName() {
      if (this.country === 1) {
        return "海外";
      } else if (this.formData.org.city) {
        return `${this.formData.org.province}-${this.formData.org.city}`;
      } else {
        return "";
      }
    },
    isUserPhone() {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      return userInfo.account === this.formData.phone;
    },
    namePhoneDisabled() {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      if (
        userInfo.account === this.formData.phone &&
        this.meetingKey === 0 &&
        !this.isPay
      ) {
        if (userInfo.user.customerType === 2) {
          return "name";
        } else {
          return "phone";
        }
      }
      return "none";
    },
  },
  filters: {
    dateFormat(type) {
      if (type === "yyyy-MM") {
        return "year-month";
      } else {
        return "date";
      }
    },
    dateTitleFormat(type) {
      if (type === "yyyy-MM") {
        return "选择年月";
      } else {
        return "选择年月日";
      }
    },
  },
  methods: {
    // -------------手机号校验--------------
    // 打开手机号校验弹窗
    toCheckPhone() {
      let phone = this.formData.phone;
      let flag = /^1[3-9]\d{9}$/.test(phone);
      if (
        phone &&
        flag &&
        this.phoneValidator(phone) &&
        !this.formData.isPhone
      ) {
        this.checkPhoneShow = true;
      }
    },
    // 打开校验图形
    getCode() {
      if (!this.verifyFlag) return;
      this.verifyShow = true;
    },
    // 图形校验成功
    async handleVerifySuccess() {
      this.verifyFlag = false;
      this.verifyShow = false;
      const res = await this.$apis.loginServe.getCode({
        phone: this.formData.phone,
        adapter: "check",
      });
      if (res.resultCode == "200") {
        Toast("获取成功");
        this.keyFlagChange();
      } else {
        this.verifyFlag = true;
        Toast(res.resultDesc);
      }
    },
    // 获取验证码时间
    keyFlagChange() {
      let timer = setInterval(() => {
        if (this.verifyTime <= 0) {
          clearInterval(timer);
          this.verifyFlag = true;
          this.verifyTime = 59;
        } else {
          this.verifyTime = --this.verifyTime;
        }
      }, 1000);
    },
    // 提交手机号和验证码
    checkPhonefirm() {
      this.$refs.checkPhoneRef.validate().then(async () => {
        const { resultCode, resultDesc } =
          await this.$apis.goodsServe.phoneValidate({
            phone: this.formData.phone,
            randomCode: this.verifyCode,
          });
        if (resultCode === "200") {
          this.verifyPhoneList.push(this.formData.phone);
          sessionStorage.setItem(
            "verifyPhoneList",
            JSON.stringify(this.verifyPhoneList)
          );
          this.formData.isPhone = true;
          this.checkPhoneShow = false;
          this.phoneGetInfo(this.formData.phone);
        } else {
          Toast(resultDesc);
        }
      });
    },
    // -------------手机号校验结束--------------
    // 通过手机号获取学者信息
    phoneBlur(e) {
      let phone = e.target.value;
      let flag = /^1[3-9]\d{9}$/.test(phone);
      if (phone && flag && this.phoneValidator(phone)) {
        if (this.isCheckPhone) {
          let isVerifyPhone = this.verifyPhoneList.some(
            (item) => item === phone
          );
          if (isVerifyPhone || this.isUserPhone) {
            this.formData.isPhone = true;
            this.phoneGetInfo(phone);
          } else {
            this.formData.isPhone = false;
          }
        } else {
          this.phoneGetInfo(phone);
        }
      }
    },
    async phoneGetInfo(phone) {
      this.formLoading = true;
      const {
        messageType,
        resultCode,
        data: userData,
      } = await this.$apis.userServe.phoneGetUserinfo(phone);
      if (resultCode === "200" && messageType === "Success") {
        const obj = this.$global.deepClone(this.meetingItem);
        for (const key in obj) {
          if (key === "name") {
            obj[key] = userData.userInfo.realname;
          } else if (key === "headPhoto") {
            if (userData.userInfo.headPhoto) {
              obj[key] = [
                {
                  fileUrl: userData.userInfo.headPhoto,
                  content: this.$global.imgUrl + userData.userInfo.headPhoto,
                  url: this.$global.imgUrl + userData.userInfo.headPhoto,
                },
              ];
            }
          } else if (key === "mailbox") {
            obj[key] = userData.userInfo.email;
          } else if (key === "birthday") {
            obj[key] = userData.userInfo[key]
              ? userData.userInfo[key].slice(0, 4)
              : "";
          } else if (key === "subjects") {
            let subjectsList = userData.subjects;
            if (subjectsList.length) {
              obj[key] = subjectsList.map((subjectItem) => ({
                fieldValue: `${subjectItem.levelOneName}/${subjectItem.levelTwoName}`,
                levelOne: subjectItem.levelOne,
                levelTwo: subjectItem.levelTwo,
              }));
            }
          } else if (key === "titles") {
            let titles = userData.titles;
            if (titles.length) {
              obj[key] = titles.map((titleItem) => ({
                levelOne: titleItem.levelOne,
                levelOneName: titleItem.levelOneName,
                levelTwo: titleItem.levelTwo,
              }));
            }
          } else if (key === "org") {
            let scholarPresentUnits = userData.scholarPresentUnits.filter(
              (i) => i.defaultStatus
            );
            if (scholarPresentUnits.length) {
              obj[key].name = scholarPresentUnits[0].unitName;
              obj[key].job = scholarPresentUnits[0].job;
              obj[key].address = scholarPresentUnits[0].address;
              obj[key].postalCode = scholarPresentUnits[0].postCode;
              obj[key].country = scholarPresentUnits[0].country;
              obj[key].province = scholarPresentUnits[0].provinceName;
              obj[key].provinceCode = scholarPresentUnits[0].province;
              obj[key].city = scholarPresentUnits[0].cityName;
              obj[key].cityCode = scholarPresentUnits[0].city;
            }
          } else if (
            key !== "phone" &&
            key !== "idCard" &&
            userData.userInfo.hasOwnProperty(key)
          ) {
            obj[key] = userData.userInfo[key];
          }
        }
        this.fillFormData(obj);
      }
      this.formLoading = false;
    },
    // 手机号重复校验
    phoneValidator(value) {
      let list = this.meetingMemberList.filter((item) => item.phone === value);
      return list.length < 2;
    },
    // 填充表单数据
    fillFormData(dataForm) {
      if (this.isCheckPhone) {
        this.formData.isPhone = dataForm.isPhone || false;
      }
      this.signFormFormat.forEach((item) => {
        if (
          item.type === "multipleChoice" ||
          item.type === "file" ||
          item.type === "imageList"
        ) {
          this.$set(
            this.formData,
            item.key,
            dataForm[item.key] ? dataForm[item.key] : []
          );
          this.formData[item.key] = dataForm[item.key] || [];
        } else if (item.type === "subjects" || item.type === "titles") {
          if (item.isMultiple) {
            this.$set(this.formData, item.key, dataForm[item.key]);
          } else {
            let arr = dataForm[item.key].slice(0, 1);
            this.$set(this.formData, item.key, arr);
          }
        } else if (item.type === "education") {
          this.$set(
            this.formData,
            item.key,
            dataForm[item.key] ? dataForm[item.key] : ""
          );
          this.$set(
            this.formData,
            "eduVal",
            dataForm.eduVal ? dataForm.eduVal : ""
          );
        } else {
          this.$set(
            this.formData,
            item.key,
            dataForm[item.key] ? dataForm[item.key] : ""
          );
        }
      });
    },
    // 关闭弹窗
    closeDatePicker() {
      this.dateKey = "";
      this.dateFormat = "yyyy-MM-dd";
      this.datePickerStatus = false;
    },
    // 选择时间
    onDateConfirm(date) {
      let stringDate = this.$global.transferDay(date);
      if (this.dateFormat === "yyyy-MM") {
        stringDate = this.$global.transferMonth(date);
      }
      this.formData[this.dateKey] = stringDate;
      this.datePickerStatus = false;
    },
    // 获取日期范围
    dataFormate() {
      let nowDate = new Date().getFullYear();
      this.minDate = new Date(nowDate - 30, 0, 1);
      this.maxDate = new Date(nowDate + 30, 11, 31);
    },
    // 自定义单选项点击
    radioClick(key, value) {
      this.formData[key] = value;
    },
    // 自定义多选项点击
    checkToggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    // 任职机构字段占位符格式化
    phFilter(key) {
      switch (key) {
        case "name":
          return "请输入机构名称";
        case "job":
          return "请输入现任职位";
        case "city":
          return "请选择省/市";
        case "address":
          return "请输入详细地址";
        case "postalCode":
          return "请输入邮编";
        default:
          return "请输入机构名称";
      }
    },
    //校验上传图片大小
    onOversize(size) {
      Toast(`文件大小不能超过${size}MB`);
    },
    //校验上传文件的格式
    beforeRead(file, isFileType = false) {
      if (!isFileType) {
        if (!/(jpg|jpeg|png|JPG|PNG)/i.test(file.type)) {
          Toast("仅支持JPG、JPEG、PNG格式");
          return false;
        }
      }
      return true;
    },
    //照片上传事件方法
    async clzpAfterRead(file) {
      const _this = this;
      file.status = "uploading";
      file.message = "上传中...";
      // 创建一个空对象实例
      let formData = new FormData();
      // 调用append()方法添加数据
      formData.append("file", file.file);
      const res = await _this.$apis.myServe.uploadFileMannual(formData);
      if (res.resultCode == 200) {
        file.status = "done";
        file.message = "上传成功";
        file.content = this.$global.imgUrl + res.content.url;
        file.url = this.$global.imgUrl + res.content.url;
        file.fileUrl = res.content.url;
        file.name = file.file.name;
      } else {
        file.status = "failed";
        file.message = "failed";
        _this.$toast(res.resultDesc);
      }
    },
    // 图片列表上传
    async handleUploadImgList(file) {
      file.status = "uploading";
      file.message = "上传中...";
      // 创建一个空对象实例
      let formData = new FormData();
      // 调用append()方法添加数据
      formData.append("file", file.file);
      const res = await this.$apis.myServe.uploadFileMannual(formData);
      if (res.resultCode == 200) {
        file.status = "done";
        file.message = "上传成功";
        this.formData.imageList.push(res.content.url);
      } else {
        file.status = "failed";
        file.message = "failed";
        this.$toast(res.resultDesc);
      }
    },
    // 图片列表删除
    handleDelImgList(info) {
      this.formData.imageList = this.formData.imageList.filter((_, idx) => {
        return idx != info.index;
      });
    },
    // 打开下拉框
    showItemOverlay(key, Ind, options, format) {
      this[key + "PickerStatus"] = true;
      if (key === "subjects") {
        this.subjectInd = Ind;
      } else if (key === "titles") {
        this.titleInd = Ind;
      } else if (key === "dropDown") {
        this.customKey = Ind;
        this.customOptions = options.map(({ value: name }) => ({ name }));
      } else if (key === "date") {
        this.dateKey = Ind;
        this.dateFormat = format;
      }
    },
    // action选择器选择
    selectAction(item, key, list) {
      if (key === "dropDown") {
        this.formData[this.customKey] = item.name;
      } else if (key === "education") {
        this.formData[key] = item[1];
        this.formData.eduVal = list.join();
      } else {
        this.formData[key] = item.name;
      }
      this[key + "PickerStatus"] = false;
    },
    // 选择学科领域
    chooseSubjects({ value, selectedOptions, tabIndex }) {
      let selectedOptionsKey = 0;
      if (selectedOptions.length === 1) {
        selectedOptions.push(selectedOptions);
        selectedOptionsKey = 1;
      }
      this.formData.subjects[this.subjectInd] = {
        levelOne: selectedOptions[0].value,
        levelTwo: selectedOptions[1].value,
        fieldValue: selectedOptionsKey
          ? selectedOptions.map((option) => option.label).join(" ")
          : selectedOptions.map((option) => option.label).join("/"),
      };
      this.subjectsPickerStatus = false;
    },
    // 选择完成，关闭学科领域
    closeSubjectCascader() {
      this.subjectsPickerStatus = false;
      this.subjectsCascaderValue = "";
    },
    // 添加学科领域
    addSubjectInfo() {
      this.formData.subjects.push({
        levelOne: "",
        levelTwo: "",
        fieldValue: "",
      });
    },
    // 选择职级
    selectTitleLevelOne(item) {
      if (item.value === "5") {
        this.formData.titles[this.titleInd].levelTwo = "";
      }
      this.formData.titles[this.titleInd].levelOne = item.value;
      this.formData.titles[this.titleInd].levelOneName = item.name;
      this.titlesPickerStatus = false;
    },
    // 添加职称
    addTitleInfo() {
      this.formData.titles.push({
        levelOne: "",
        levelOneName: "",
        levelTwo: "",
      });
    },
    // 获取市区options
    async cityLists(value) {
      var provinceIndex = this.areaComOptions.findIndex((item) => {
        return item.value == value;
      });
      let res = await this.$apis.userServe.cityList({
        provinceCode: Number(value),
      });
      let cityList = res.content.cityList.map((item) => ({
        label: item.name,
        value: item.code,
      }));
      this.$set(this.areaComOptions[provinceIndex], "children", cityList);
    },
    // 省市case变化
    areaOnChange({ value, selectedOptions, tabIndex }) {
      if (tabIndex === 0) {
        if (selectedOptions[0].children.length === 0) {
          this.cityLists(value);
        }
      }
    },
    // 省市case选择
    areaOnFinish({ selectedOptions }) {
      if (this.country === 0) {
        this.formData.org.province = selectedOptions[0].label;
        this.formData.org.provinceCode = selectedOptions[0].value;
        this.formData.org.city = selectedOptions[1].label;
        this.formData.org.cityCode = selectedOptions[1].value;
        this.formData.org.country = 0;
      } else {
        this.formData.org.province = "";
        this.formData.org.provinceCode = "";
        this.formData.org.city = "";
        this.formData.org.cityCode = "";
        this.formData.org.country = 1;
      }
      this.areaPickerStatus = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-box {
  position: relative;

  &::v-deep .van-field__label {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .headPhoto-box {
    // 头像预览圆形
    &::v-deep .van-uploader__upload {
      margin: 0;
      border: solid 1px #eee;
      border-radius: 50%;
      background-color: #fff;
      .van-uploader__input {
        width: 100%;
        height: 100%;
      }
    }

    &::v-deep .van-uploader__preview {
      position: relative;
      margin: 0;
      .van-uploader__preview-image {
        border-radius: 50%;
      }
    }
  }
  .radio-box {
    ::v-deep .van-radio__icon {
      height: inherit;
      // line-height: 30px;
      font-size: unset;
      // 性别，是否在读，单选按钮默认样式
      .radio-btn-default {
        width: 60px;
        height: 30px;
        background: #f5f5f5;
        color: #333333;
        border: 0;
      }

      // 性别，是否在读，单选按钮选中样式
      .radio-btn-default.radio-btn-active {
        background: #4a79f1;
        color: #ffffff;
      }
    }
  }
  .titles-box {
    width: 100%;
    .titles-item {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      margin-bottom: 10px;
      border-bottom: 1px solid #f5f6f7;
      &:last-of-type {
        margin-bottom: 0;
        padding-bottom: 0;
        border: none;
      }
      ::v-deep .van-cell {
        &::after {
          display: none;
        }
      }
      .title-pick {
        flex: none;
        padding: 0;
        width: 60px;
        ::v-deep .van-icon {
          margin-left: 6px;
          color: #969799;
          font-size: 9px;
        }
      }
    }
  }
  .subject-box {
    width: 100%;
    .subject-item {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      margin-bottom: 10px;
      border-bottom: 1px solid #f5f6f7;
      ::v-deep .van-cell {
        &::after {
          display: none;
        }
      }
      &:last-of-type {
        margin-bottom: 0;
        padding-bottom: 0;
        border: none;
      }
    }
  }
  .right-btn {
    flex: none;
    margin-left: 5px;
    padding: 8px 4px;
    width: 18px;
    height: 18px;
    border: none;
    background-color: #f5f5f5;
    ::v-deep .van-button__text {
      display: inline-block;
      width: 100%;
      height: 100%;
      background-color: #333;
      border-radius: 3px;
    }
  }
  .add-btn {
    padding: 0;
    margin-left: 108px;
    height: 25px;
    line-height: 1;
    border: 0;
    color: #4a79f1;
  }
  .org-box {
    width: 100%;
    .org-item {
      padding-bottom: 10px;
      margin-bottom: 10px;
      border-bottom: 1px solid #f5f6f7;
      &:last-of-type {
        margin-bottom: 0;
        padding-bottom: 0;
        border: none;
      }
      ::v-deep .van-cell {
        &::after {
          display: none;
        }
      }
    }
  }
  &::v-deep .tab-box {
    flex: none;
    padding: 0 25px;
    font-size: 16px;
    // width: 50px;
  }
  &::v-deep .van-tabs__line {
    background-color: #4a79f1;
    width: 20px;
  }
  .customize-radio-box {
    width: 100%;
    &::v-deep .van-cell-group {
      &::after {
        display: none;
      }
      .customize-radio-item {
        margin-bottom: 10px;
        .van-radio,
        .van-checkbox {
          flex: none;
          margin-left: 5px;
        }
        &:last-child {
          margin-bottom: 0;
        }
        &::after {
          display: none;
        }
      }
    }
  }
  .tip {
    margin-bottom: 8px;
    // padding-bottom: 14px;
    width: 200px;
    line-height: 28px;
    color: #cccccc;
    border-bottom: 1px solid #f5f6f7;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .loading-box {
    position: absolute;
    top: 0;
    left: 0;
    padding-top: 50%;
    text-align: center;
    width: 100%;
    height: 100%;
    background-color: #ffffffb3;
  }
  .verify-btn-box {
    .verify-btn {
      color: #4a79f1;
    }
    &.van-field--error {
      .verify-btn {
        color: #ee0a24;
      }
    }
    &::v-deep .van-field__error-message {
      display: none;
    }
  }
}
.verify-box {
  h1 {
    margin-bottom: 25px;
    font-size: 16px;
    color: #333333;
  }
  .verify-form {
    .verify-form-item {
      margin-bottom: 12px;
      background-color: #f5f5f5;
      border-radius: 6px;
      &::after {
        display: none;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
